/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { ClosePlayerButton } from "../../Interface";

import { ContinueWatchingDialog } from "./Component";

import "./Container.scss";

export const ContinueWatchingOverlay = () => {
  return (
    <div className="OverlayContainer">
      <div className="OverlayContainer__TopSection">
        <ClosePlayerButton />
      </div>
      <div className="OverlayContainer__CenterSection">
        <ContinueWatchingDialog />
      </div>
    </div>
  );
};
